<template>
    <div>
        <h4 class="mb-1">
            {{ lang.title }}
        </h4>

        <!-- <form @submit.prevent="register" @keydown="form.errors.clear($event.target.name)"> -->
        <div>
            <!-- <input
                v-model="form.email"
                name="email"
                type="hidden"
            /> -->

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <my-input
                            v-model="form.first_name"
                            name="first_name"
                            type="string"
                            :label="lang.placeholders.first_name"
                            @input="form.errors.clear('first_name')"
                            :autofocus="true"
                        />
                        <error-span :error="form.errors.get('first_name')"></error-span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <my-input
                            v-model="form.last_name"
                            name="last_name"
                            type="string"
                            :label="lang.placeholders.last_name"
                            @input="form.errors.clear('last_name')"
                        />
                        <error-span :error="form.errors.get('last_name')"></error-span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <my-input
                            v-model="form.phone"
                            name="phone"
                            type="string"
                            :label="lang.placeholders.phone"
                            @input="form.errors.clear('phone')"
                        />
                        <error-span :error="form.errors.get('phone')"></error-span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <my-input
                            v-model="form.password"
                            name="password"
                            type="password"
                            :label="lang.placeholders.password"
                            @input="form.errors.clear('password')"
                        />
                        <error-span :error="form.errors.get('password')"></error-span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <my-input
                            v-model="form.password_verify"
                            name="password_verify"
                            type="password"
                            :label="lang.placeholders.password_verify"
                            @input="form.errors.clear('password_verify')"
                        />
                        <error-span :error="form.errors.get('password_verify')"></error-span>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col">
                    <div class="password_recovery">
                        <a :href="lang.password_recovery_url" class="btn btn-text">
                            {{ lang.labels.password_recovery|capitalize }}
                        </a>
                    </div>
                </div> -->
                <div class="col" v-if="$root.country == 'it'">
                    <div class="privacy_link">
                        <privacy-checkbox
                            v-model="form.register"
                            name="register"
                            id="lead-register-checkbox"
                            :textPrivacy="lang.privacy"
                            :langPrivacy="langPrivacy"
                            modal="register"
                            @input="form.errors.clear('register')"
                        />
                        <error-span :error="form.errors.get('register')" />
                    </div>
                    <!-- <div class="privacy_link">
                        <privacy-checkbox
                            v-model="form.marketing"
                            name="marketing"
                            id="lead-marketing-checkbox"
                            :textPrivacy="lang.marketing"
                            :langPrivacy="langPrivacy"
                            modal="marketing"
                        />
                        <error-span :error="form.errors.get('marketing')" />
                    </div> -->
                </div>
                
            </div>

            <button class="btn btn-network" @click="register()">
                {{ lang.labels.login }}
            </button>
        </div>
        <!-- </form> -->
    </div>
</template>

<script>
import { Form } from '../../classes/Form'
import PrivacyCheckbox from '../form/PrivacyCheckbox'

export default {
    components: {
        'privacy-checkbox': PrivacyCheckbox,
    },

    props: {
    },

    data() {
        return {
            error: '',
            form: new Form({
                email: '',
                first_name: '',
                last_name: '',
                password: '',
                password_verify: '',
                phone: '',
                register: false,
                // marketing: false,
            }),
            message: '',
            rules: {
                // email: ['required'],
                first_name: ['required'],
                last_name: ['required'],
                password: ['required'],
                password_verify: ['required', 'same_as:password'],
                phone: ['required'],
                register: ['required'],
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },

        langPrivacy() {
            return this.$root.lang.privacy
        },
    },

    methods: {
        register() {
            if(! this.form.validate(this.rules)) {
                return false
            }
            this.$emit('registerSuccess', this.form)
        },
    },
}
</script>